"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _imask = _interopRequireDefault(require("imask"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var CustomDateMask = /*#__PURE__*/function (_IMask$MaskedDate) {
  (0, _inherits2.default)(CustomDateMask, _IMask$MaskedDate);

  var _super = _createSuper(CustomDateMask);

  function CustomDateMask() {
    var _this;

    (0, _classCallCheck2.default)(this, CustomDateMask);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "queue", '');
    return _this;
  }

  (0, _createClass2.default)(CustomDateMask, [{
    key: "_appendChar",
    value: // eslint-disable-next-line no-underscore-dangle
    function _appendChar(char, flags, checkTail) {
      // eslint-disable-next-line no-underscore-dangle
      var details = (0, _get2.default)((0, _getPrototypeOf2.default)(CustomDateMask.prototype), "_appendChar", this).call(this, char, flags, checkTail);

      for (var queueIndex = 0; queueIndex < Math.min(10, this.queue.length); queueIndex += 1) {
        details.aggregate( // eslint-disable-next-line no-underscore-dangle
        (0, _get2.default)((0, _getPrototypeOf2.default)(CustomDateMask.prototype), "_appendChar", this).call(this, this.queue[queueIndex], flags, checkTail));
      }

      this.queue = '';
      return details;
    }
  }]);
  return CustomDateMask;
}(_imask.default.MaskedDate);

var _default = CustomDateMask;
exports.default = _default;
